// extracted by mini-css-extract-plugin
export var linkText = "_pf-0";